var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-field',{attrs:{"label":"餐點備註","autosize":"","type":"textarea","maxlength":"20","placeholder":"请输入留言","show-word-limit":"","label-align":"top"},on:{"blur":_vm.onChange},model:{value:(_vm.s2.DispName),callback:function ($$v) {_vm.$set(_vm.s2, "DispName", $$v)},expression:"s2.DispName"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }